
<div class="flex flex-col md:flex-row">
    <!--TODO - add element to display when a chart has a render error-->
    
    <!--Chart 1-->
    <div class="sm:col-span-2 md:col-span-4 lg:col-span-2 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden max-w-md mr-2">
        <div class="flex flex-col sm:flex-row items-start items-center">
            <div class="text-lg font-medium tracking-tight leading-6 truncate">
                File Count
            </div>
            <mat-icon 
                class="icon-size-4 ml-1" 
                matTooltip="Count of files currently within folder, excluding subfolders."
                svgIcon="heroicons_outline:information-circle">
            </mat-icon>
        </div>
        <div class="flex flex-row" *ngIf="chartFileCount.series">
            <apx-chart
            class="flex-auto h-80"
            [chart]="$any(chartFileCount.chart)"
            [colors]="chartFileCount.colors || []"
            [labels]="$any(chartFileCount.labels)"
            [legend]="$any(chartFileCount.legend)"
            [plotOptions]="$any(chartFileCount.plotOptions)"
            [series]="$any(chartFileCount.series)"
            [states]="$any(chartFileCount.states)"
            [stroke]="$any(chartFileCount.stroke)"
            [tooltip]="$any(chartFileCount.tooltip)"
            [yaxis]="$any(chartFileCount.yaxis)"></apx-chart>
        </div>
    </div>
    
    <!--Chart 2-->
    <div class="sm:col-span-2 md:col-span-4 lg:col-span-2 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden max-w-md  mr-2">
        <div class="flex flex-col sm:flex-row items-start ">
            <div class="text-lg font-medium tracking-tight leading-6 truncate">
                Recent Modifications
            </div>
            <mat-icon 
                class="icon-size-4 ml-1" 
                matTooltip="Uploads and Edits in the last 30 days by file type"
                svgIcon="heroicons_outline:information-circle">
            </mat-icon>
        </div>
        <div class="flex flex-row" *ngIf="chartFileDistribution.series">
            <apx-chart
            class="flex-auto h-80"
            [chart]="$any(chartFileDistribution.chart)"
            [colors]="chartFileDistribution.colors || []"
            [labels]="$any(chartFileDistribution.labels)"
            [legend]="$any(chartFileDistribution.legend)"
            [plotOptions]="$any(chartFileDistribution.plotOptions)"
            [series]="$any(chartFileDistribution.series)"
            [states]="$any(chartFileDistribution.states)"
            [stroke]="$any(chartFileDistribution.stroke)"
            [tooltip]="$any(chartFileDistribution.tooltip)"
            [yaxis]="$any(chartFileDistribution.yaxis)"></apx-chart>
           
        </div>
    </div>
    
</div>

